import FolxLoader from './FolxLoader.component';

export default FolxLoader;
